import { Injectable } from '@angular/core';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { MilestoneStore } from './milestone.store';
import { MilestoneQuery } from './milestone.query';
import ColorHash from 'color-hash';
import { ID } from '@common/interfaces/id';
import { PartialUpdate } from '@common/interfaces/base';
import { IMilestone } from '@common/interfaces/milestone';

@Injectable({
  providedIn: 'root'
})
export class MilestoneService extends CrudService<IMilestone, MilestoneStore, MilestoneQuery> {

  colorHash = new ColorHash();

  constructor(
    protected store: MilestoneStore,
    public query: MilestoneQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.MILESTONES,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

  
  setActive(id: ID) {
    this.store.setActive(id);
  }
  
  persistMilestones(milestones: IMilestone[], projectId: ID) {
    milestones = milestones.map(milestone => ({
      ...milestone,
      id: milestone.id.replace('new_', ''),
      projectId
    }));
    for (const milestone of milestones) {
      if (!this.query.getEntity(milestone.id)) {
        super.create(milestone);
      }
    }
  }

  trash(id: ID) {
    this.update({ id, trashedAt: (new Date()).toISOString() } as PartialUpdate<IMilestone>);
  }

  restoreFromTrash(id: ID) {
    this.update({ id, trashedAt: null } as PartialUpdate<IMilestone>);
  }

}
